<template>
  <div :class="$b()">
    <LoadingOverlay
      :force="loading"
      :full-screen="false"
      standalone
    />

    <PrimaryButton disabled>
      Sold Out
    </PrimaryButton>

    <BaseCopy size="body">
      {{ customisedProduct.product.pdpConfig.registerInterestFormCopy }}
    </BaseCopy>

    <TextInput
      v-model="email"
      type="email"
      mode="grey"
      shape="rounded"
      placeholder="your@email.com"
      :class="$b('input')"
      :disabled="subscribed"
      @keyup.enter="submit"
    >
      <PrimaryButton
        :class="$b('button')"
        :disabled="subscribed"
        size="small"
        @click="submit"
      >
        Sign Up
      </PrimaryButton>
    </TextInput>

    <SlideDownTransition>
      <BaseCopy
        v-if="message"
        key="message"
        size="body-sm"
      >
        {{ $tr(message) }}
      </BaseCopy>
    </SlideDownTransition>
  </div>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'

export default {
  name: 'RegisterInterestForm',
  props: {
    customisedProduct: {
      type: CustomisedProduct,
      required: true,
    },
  },
  data: () => ({
    email: null,
    message: null,
    subscribed: false,
    loading: false,
  }),
  methods: {
    async submit() {
      if (!this.email) return

      this.loading = true

      try {
        const response = await $fetch('https://events.hookdeck.com/e/src_RXad7QfgPLwu', {
          method: 'POST',
          body: {
            timestamp: new Date().toISOString(),
            email: this.email,
            productName: this.customisedProduct.name,
            sku: this.customisedProduct.sku,
            baseSKU: this.customisedProduct.baseSKU,
          },
        })

        // If response is unsuccessful then throw error
        if (response.status !== 'SUCCESS')
          throw new Error(`Unexpected response status: ${response.status}`)

        this.subscribed = true
        this.message = 'Thank you for registering your interest.'
      } catch (error) {
        console.error(error)
        this.$sentry.captureException(error)
        this.message = 'Something went wrong, please try again.'
      }

      this.loading = false
    },
  },
}
</script>

<style lang="postcss">
.RegisterInterestForm {
  @apply flex flex-col gap-xxs mb-sm
    relative;

  .TextInput__append {
    @apply m-[0.25rem];
  }
}

.RegisterInterestForm__input {
  @apply w-full;
}

.RegisterInterestForm__button {
  @apply whitespace-nowrap;
}
</style>
